const SvgTransform2 = (props) => (
  <>
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="M51.97 256h55.69M172 384H52M115.61 256H172M176 380V260M48 259.74V380M115.62 255.89C149.28 254.01 176 226.13 176 192s-26.53-61.8-60.01-63.86M108.01 128.14C74.52 130.2 48 158 48 192s26.33 61.6 59.65 63.84M49.78 3.57l60.44 120.87M52 0h119M174.06 3.88l-60.28 120.56M48 380c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4"
    />
    <path
      d="M48 380c.64 0 1.25.16 1.79.43 1.31.66 2.21 2.01 2.21 3.57M176 380c-.64 0-1.25.16-1.79.43A3.999 3.999 0 0 0 172 384"
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
    />
    <path
      d="M176 380c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4M49.78 3.57C51.09 2.91 52 1.57 52 0"
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
    />
    <path
      d="M52 0c0-2.14-1.69-3.89-3.8-3.99H48c-2.21 0-4 1.79-4 4s1.79 4 4 4h.2c.57-.03 1.1-.18 1.59-.42M174.06 3.88c.24.06.49.1.74.11h.2c2.21 0 4-1.79 4-4s-1.79-4-4-4h-.2c-2.12.1-3.8 1.85-3.8 3.99M174.06 3.88A4 4 0 0 1 171 0M108.01 128.14s-.01-.09-.01-.14c0-.07 0-.13.01-.2a3.97 3.97 0 0 1 2.21-3.36M110.22 124.44c.54-.27 1.14-.44 1.78-.44s1.24.17 1.78.44M108.01 128.14c.07 2.15 1.82 3.86 3.99 3.86s3.91-1.72 3.99-3.86M115.99 128.14s.01-.09.01-.14c0-.07 0-.13-.01-.2a3.97 3.97 0 0 0-2.21-3.36M176 260c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4"
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
    />
    <path
      d="M176 260c-2.21 0-4-1.79-4-4M115.62 255.89c0-.05.02-.1.02-.15 0-.07 0-.13-.01-.2-.1-2.12-1.85-3.8-3.99-3.8s-3.89 1.69-3.99 3.8c0 .07-.01.13-.01.2v.09M115.61 256c-.14 2.09-1.85 3.74-3.97 3.74s-3.84-1.66-3.97-3.74M115.62 255.89s0 .07-.01.11M107.65 255.84c0 .06.01.11.02.16M51.97 256c0-.09.03-.17.03-.26 0-2.21-1.79-4-4-4s-4 1.79-4 4 1.79 4 4 4"
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
    />
    <path d="M48 259.74c2.12 0 3.84-1.66 3.97-3.74" fill="none" stroke={props.p50} strokeMiterlimit={10} />
  </>
);

export default SvgTransform2;
